import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axios from 'axios';
import Timeline from './Timeline';
import 'primereact/resources/themes/saga-blue/theme.css'; // Import the theme
import 'primereact/resources/primereact.min.css'; // Core CSS
import 'primeicons/primeicons.css'; // Icons
import 'primeflex/primeflex.css'; // PrimeFlex CSS
import './ViewCalibrationDevice.css';

const ViewCalibrationDevice = ({ userRole }) => {
  const { id } = useParams(); // This should be the SerialNumber
  const navigate = useNavigate();
  const [device, setDevice] = useState(null);
  const [loading, setLoading] = useState(true);

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchDevice = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/api/calibration-device/${id}`);
        setDevice(response.data);
      } catch (error) {
        console.error('Error fetching device:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDevice();
  }, [id, apiBaseUrl]);

  const handleBack = () => {
    navigate('/calibration-devices');
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!device) {
    return <div>Device not found</div>;
  }

  return (
    <div className="view-device-item-container">
      <h1>View Calibration Device</h1>
      <div className="device-details">
        <p><strong>Category:</strong> {device.Category}</p>
        <p><strong>Serial Number:</strong> {device.SerialNumber}</p>
        <p><strong>Owning Location:</strong> {device.OwningLocation}</p>
        <p><strong>Manufacturer:</strong> {device.Manufacturer}</p>
        <p><strong>Model Number:</strong> {device.ModelNumber}</p>
        <p><strong>SES Number:</strong> {device.SESNumber}</p>
      </div>
      {userRole === 'Admin' && (
        <button 
          className="edit-device-button"
          onClick={() => navigate(`/edit-calibration-device/${id}`)}
        >
          Edit Device
        </button>
      )}
      <button onClick={handleBack} className="view-device-back-button">Back</button>
    </div>
  );
};

export default ViewCalibrationDevice;
